const OurserviceFirstLoad = () => {
  document?.getElementById("root")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
export default OurserviceFirstLoad;
